import React from 'react';
import './Brands.css';

const Brands = () => {
  const brands = [
    { name: 'JBL', logo: 'https://via.placeholder.com/200x80/1a1a1a/d4af37?text=JBL' },
    { name: 'Bose', logo: 'https://via.placeholder.com/200x80/1a1a1a/d4af37?text=BOSE' },
    { name: 'QSC', logo: 'https://via.placeholder.com/200x80/1a1a1a/d4af37?text=QSC' },
    { name: 'Yamaha', logo: 'https://via.placeholder.com/200x80/1a1a1a/d4af37?text=YAMAHA' },
    { name: 'Electro-Voice', logo: 'https://via.placeholder.com/200x80/1a1a1a/d4af37?text=EV' },
    { name: 'RCF', logo: 'https://via.placeholder.com/200x80/1a1a1a/d4af37?text=RCF' },
    { name: 'Alto Professional', logo: 'https://via.placeholder.com/200x80/1a1a1a/d4af37?text=ALTO' },
    { name: 'Behringer', logo: 'https://via.placeholder.com/200x80/1a1a1a/d4af37?text=BEHRINGER' },
    { name: 'Mackie', logo: 'https://via.placeholder.com/200x80/1a1a1a/d4af37?text=MACKIE' },
    { name: 'Soundcraft', logo: 'https://via.placeholder.com/200x80/1a1a1a/d4af37?text=SOUNDCRAFT' },
    { name: 'Allen & Heath', logo: 'https://via.placeholder.com/200x80/1a1a1a/d4af37?text=A%26H' },
    { name: 'Crown', logo: 'https://via.placeholder.com/200x80/1a1a1a/d4af37?text=CROWN' },
    { name: 'Shure', logo: 'https://via.placeholder.com/200x80/1a1a1a/d4af37?text=SHURE' },
    { name: 'Sennheiser', logo: 'https://via.placeholder.com/200x80/1a1a1a/d4af37?text=SENNHEISER' },
    { name: 'Audio-Technica', logo: 'https://via.placeholder.com/200x80/1a1a1a/d4af37?text=AUDIO-TECHNICA' },
    { name: 'AKG', logo: 'https://via.placeholder.com/200x80/1a1a1a/d4af37?text=AKG' },
    { name: 'Presonus', logo: 'https://via.placeholder.com/200x80/1a1a1a/d4af37?text=PRESONUS' },
    { name: 'Furman', logo: 'https://via.placeholder.com/200x80/1a1a1a/d4af37?text=FURMAN' },
    { name: 'ProCo', logo: 'https://via.placeholder.com/200x80/1a1a1a/d4af37?text=PROCO' },
    { name: 'Ultimate Support', logo: 'https://via.placeholder.com/200x80/1a1a1a/d4af37?text=ULTIMATE' }
  ];

  return (
    <div className="brands-page">
      {/* Hero Section */}
      <section className="brands-hero">
        <div className="brands-hero-overlay"></div>
        <div className="brands-hero-content">
          <h1>Our Partner Brands</h1>
          <p>
            We partner with the world's most prestigious audio brands to deliver uncompromising 
            quality and performance
          </p>
        </div>
      </section>

      {/* Brands Grid Section */}
      <section className="brands-grid-section">
        <div className="container">
          <div className="section-header">
     
          </div>

          <div className="brands-grid">
            {brands.map((brand, index) => (
              <div className="brand-logo-card" key={index}>
                <img src={brand.logo} alt={brand.name} />
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Brands;
